import { createContext, useContext, useEffect, useMemo, useState } from "react";

import api from "../lib/api";
import { Loading } from "../components/shared";

const SocietyFeatureContext = createContext(null);

export function SocietyFeatureProvider({ children }) {
  const [features, setFeatures] = useState(null);

  const loadFeatures = async () => {
    try {
      const response = await api.get("/features/portal");
      setFeatures(response.data);
    } catch {
      setFeatures([]);
    }
  };

  useEffect(() => {
    loadFeatures();
  }, []);

  const value = useMemo(
    () => ({
      features,
      loading: features === null,
      reloadFeatures: loadFeatures,
      byKey: (featureKey) =>
        features?.find((feature) => feature.feature_key === featureKey),
    }),
    [features],
  );

  return (
    <SocietyFeatureContext.Provider value={value}>
      {children}
    </SocietyFeatureContext.Provider>
  );
}

export function useSocietyFeatures() {
  return useContext(SocietyFeatureContext);
}

export function FeatureGate({ children, featureKey }) {
  const context = useSocietyFeatures();
  const feature = context?.byKey(featureKey);

  if (context?.loading) {
    return <Loading />;
  }

  if (!feature?.allowed) {
    return (
      <div
        className="border-l-4 border-amber-500 bg-amber-50 px-6 py-10"
        data-testid={`feature-disabled-${featureKey}`}
      >
        <h1 className="font-display text-2xl font-bold">Feature unavailable</h1>
        <p className="mt-2 max-w-xl text-sm text-amber-900">
          This feature is not currently enabled for your Society. Contact your
          Society administrator or platform support for access details.
        </p>
      </div>
    );
  }

  return children;
}
